import * as React from "react";
import { Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
const videos = [{
  id: "vid-1",
  url: "https://www.youtube.com/embed/vJiMbySDkxU?si=McgJ6uFrqf0LXM14",
  title: "Latest Worship Session 1"
}, {
  id: "vid-2",
  url: "https://www.youtube.com/embed/H1kPLi8xN8w?si=LMdyCjjUxrrNCgOJ",
  title: "Latest Worship Session 2"
}, {
  id: "vid-3",
  url: "https://www.youtube.com/embed/dHQRDZ4Ckq0?si=YeBlCstJx-hF0azB",
  title: "Latest Worship Session 3"
}, {
  id: "vid-4",
  url: "https://www.youtube.com/embed/0-gMceubzAo?si=UlxF6KMZsllgWSI4",
  title: "Latest Worship Session 4"
}, {
  id: "vid-5",
  url: "https://www.youtube.com/embed/FhECDErgwck?si=4Y7Y9Ixr0y1Yu-Ua",
  title: "Latest Worship Session 5"
}, {
  id: "vid-6",
  url: "https://www.youtube.com/embed/S3uKH5aFqYE?si=H7UF84szqDyrEAxu",
  title: "Latest Worship Session 6"
}];
const videoVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95,
    y: 20
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0
  }
};
export default function LatestVideos() {
  return <section id="latest-videos" className="dark bg-background text-foreground pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-white text-center mb-8 tracking-tight">
          Latest Videos
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {videos.map((video, i) => <motion.div key={video.id} data-index={i} className="group relative overflow-hidden rounded-[12px] bg-muted transition-all duration-300" initial="hidden" whileInView="visible" whileHover={{
          scale: 1.05,
          y: -5,
          boxShadow: "0px 20px 40px rgba(79, 70, 229, 0.4)"
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} variants={videoVariants}>
              <AspectRatio ratio={16 / 9}>
                <iframe src={video.url} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen loading="lazy" className="absolute inset-0 h-full w-full border-0" />
              </AspectRatio>
            </motion.div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-6 text-base font-bold transition-colors">
            <Link to="https://youtube.com/@yohanneswakgariofficialcha6717?si=VCP31jg0gXEzSjqu" newtab aria-label="View more videos on Yohannes Wakgari Official YouTube channel">
              <Youtube className="mr-2 h-5 w-5" />
              View More on YouTube
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}